const PAYMENT_METHODS = {
  CARD: "card",
  PAYPAL: "paypal",
};

export { PAYMENT_METHODS };
